export default function PHP_date_interval_create_from_date_string() {
  return (
    <div>
      <h1>PHP_date_interval_create_from_date_string</h1>
    </div>
  );
}
